import { render, staticRenderFns } from "./frequency.vue?vue&type=template&id=44354e88&scoped=true"
import script from "./frequency.vue?vue&type=script&lang=js"
export * from "./frequency.vue?vue&type=script&lang=js"
import style0 from "./frequency.vue?vue&type=style&index=0&id=44354e88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44354e88",
  null
  
)

export default component.exports